import React from "react";
import { Link, useLocation } from "react-router-dom";

interface HAsideProps {
  isOpen: boolean;
  onClose: () => void;
}

const HAside: React.FC<HAsideProps> = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const outsideRef = React.useRef(null);

  const handleCloseOnOverlay = (
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    if (e.target === outsideRef.current) {
      onClose();
    }
  };

  isOpen
    ? (document.body.style.overflowY = "hidden")
    : (document.body.style.overflowY = "scroll");

  return isOpen ? (
    <>
      <aside
        data-v-dde546dc=""
        className="el-aside app-sidebar active"
        style={{ width: 250 }}
      >
        <ul
          data-v-f5844412=""
          role="menubar"
          className="app-sidebar__menu el-menu"
        >
          <Link to="/dashboard">
            <li
              // data-v-f5844412=""
              // role="menuitem"
              // tabIndex={-1}
              className={
                splitLocation[1] === "dashboard"
                  ? "el-menu-item is-active"
                  : "el-menu-item"
              }
              //className="el-menu-item "
              style={{ paddingLeft: "20px" }}
            >
              <i data-v-f5844412="" className="icofont-settings icon-menu"></i>
              <span data-v-f5844412="">Кабинет</span>
            </li>
          </Link>

          <Link to="/profile">
            <li
              data-v-f5844412=""
              role="menuitem"
              tabIndex={-1}
              className={
                splitLocation[1] === "profile"
                  ? "el-menu-item is-active"
                  : "el-menu-item"
              }
              style={{ paddingLeft: 20 }}
            >
              <i data-v-f5844412="" className="icofont-id icon-menu"></i>
              <span data-v-f5844412="">Аккаунт</span>
            </li>
          </Link>

          <Link to="/doc">
            <li
              data-v-f5844412=""
              role="menuitem"
              tabIndex={-1}
              className={
                splitLocation[1] === "doc"
                  ? "el-menu-item is-active"
                  : "el-menu-item"
              }
              style={{ paddingLeft: 20 }}
            >
              <i
                data-v-f5844412=""
                className="icofont-law-document icon-menu"
              ></i>

              <span data-v-f5844412="">Договор</span>
            </li>
          </Link>
        </ul>
      </aside>
      <div
        data-v-dde546dc
        ref={outsideRef}
        className="app__overlay"
        onClick={handleCloseOnOverlay}
      />
    </>
  ) : null;
};

export default HAside;
